import { Box, Typography, Divider, } from "@mui/material";
import DataTable from "../../dataTable";
import { useState } from "react";
import { t } from "@lingui/core/macro";
import { useGetQuery } from "../../../hooks/useGetQuery";
import { TaxonomyEntryPointList } from "../../../api/customObjectsTypes";
import TaxonomyDialog from "./taxonomyDialog";
import { AlertMessage } from "../../../api/types";

export const TaxonomyEntryPoints = ({
    id,
    setAlertMessage,
}: {
    id: string;
    setAlertMessage: (alertMessage: AlertMessage) => void
}) => {
    const [shouldFetch, setShouldFetch] = useState(true);
    const [selectedId, setSelectedId] = useState<string | null>(null);
    const [cacheBuster] = useState(crypto.randomUUID());

    const { data, loading, } = useGetQuery<TaxonomyEntryPointList>(
        `/api/taxonomies/${id}/entrypoints/configurations?cb=${cacheBuster}`,
        !id || !shouldFetch
    );

    return (
        <>
            <Box sx={{ pt: 2, pb: 2 }}>
                <Typography variant="h6">{t`Entry Points`}</Typography>
                <Divider />

            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", flexWrap: "wrap" }}>
                <DataTable<TaxonomyEntryPointList>
                    data={Array.isArray(data) ? data : []}
                    columns={Tablecolumns()}
                    loading={loading}
                    noDataMessage={t`No entry points found`}
                    onClickRow={(row) => setSelectedId(row)}
                    noWidth
                />
            </Box>
            <TaxonomyDialog
                selectTemplate="entryPoint"
                open={!!selectedId}
                onClose={(updateStatus, reason) => {
                    setSelectedId(null);
                    if (updateStatus) {
                        setAlertMessage({ message: reason || "", severity: updateStatus });
                        setShouldFetch(true);
                    }
                }}
                parentId={id}
                id={selectedId || ""}
            />
        </>
    );
};

const Tablecolumns = () =>
    [
        {
            header: {
                id: "entryPoint",
                label: t`Entry point`,
            },
            key: "entryPoint",
            valueFormatter: (row: TaxonomyEntryPointList) =>
                row?.schemaRef,
            width: 165,
        },
        {
            header: {
                id: "label",
                label: t`Label`,
            },
            key: "label",
            valueFormatter: (row: TaxonomyEntryPointList) => (
                <div>
                    {row?.labels?.map((l, idx) => (
                        <div key={idx}>{l?.text}</div>
                    ))}
                </div>
            ),
            width: 165,
        }
    ];